import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { routeParams } from '../../../../shared/shared.global-service';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import {
    SOCIAL_CREDIT_SETTINGS_DEFAULT, SOCIAL_SERVICE_SETTINGS_CREDITS_TYPE_KEY, SocialCreditSettings,
} from '@libs/types/src/services/types/social-credit-settings.types';
import { featureOn } from '../../../../../feature-flag';

@Injectable()
export class ServicesGroupsPageStore extends ComponentStoreV2Factory {

    public service = computed(() => this.globalGlobalStore.organizationStore.getServiceBySignalId(routeParams.serviceId)());

    public isSocial = computed(() => this.service()?.type === ServiceTypeEnum.SOCIAL);

    public creditsEnabled = computed(() => featureOn.SOCIAL_CREDITS &&
        this.globalGlobalStore.organizationStore.getServiceSetting<SocialCreditSettings>(
            routeParams.serviceId(), SOCIAL_SERVICE_SETTINGS_CREDITS_TYPE_KEY, SOCIAL_CREDIT_SETTINGS_DEFAULT,
        ).useCard,
    );

}
